const SVGWrapper = (elements, width = 400, height = 200, viewBox = "-200 -200 400 400") => (
  <svg width={width} height={height} viewBox={viewBox}>
    {elements}
  </svg>
);

export default SVGWrapper;
